import { render, staticRenderFns } from "./FormFooter.vue?vue&type=template&id=adafcae4&scoped=true"
import script from "./FormFooter.vue?vue&type=script&lang=ts"
export * from "./FormFooter.vue?vue&type=script&lang=ts"
import style0 from "./FormFooter.vue?vue&type=style&index=0&id=adafcae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adafcae4",
  null
  
)

export default component.exports